import React from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { closeNotification } from './ducks/notificationModal';
import sanitizeHtml from 'sanitize-html';
import { sanitizeOption } from 'lib/sanitizeHtml';


const NotificationContentItem = ({ notification }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { school } = useParams();

    function gotoPage(link) {
        navigate(link);
        dispatch(closeNotification());
    }

    let link = null;

    if (notification.referenceId !== undefined && notification.referenceId !== null && notification.referenceId !== '') {
        switch (notification.service) {
            case "DEBATE":
                link = `/${school}/book/${notification.isbn}/debate/${notification.referenceId}`;
                break;
            case "REPORT":
                link = `/${school}/bookreport/view/${notification.referenceId}`;
                break;
            case "PICTURE":
                link = `/${school}/picture/view/${notification.referenceId}`;
                break;
            case "PHOTO":
                link = `/${school}/photo/view/${notification.referenceId}`;
                break;
            case "VIDEO":
                link = `/${school}/video/view/${notification.referenceId}`;
                break;
            case "QNA":
                link = `/${school}/board/qna/view/${notification.referenceId}`;
                break;
            case "MEETING":
                link = `/${school}/meeting?id=${notification.referenceId}`;
                break;
            case "USER_BOOK":
                link = `/${school}/userbook/view/${notification.referenceId}`;
                break;
            case "USER_BOOK_EPISODE":
                link = `/${school}/userbook/episode/view/${notification.referenceId}`;
                break;
            case 'DONGWHA':
                link = `/${school}/donghwa/story/${notification.referenceId}`;
                break;
            default:
        }
    }

    let content = notification.content;
    if (notification.fromUserId !== null &&
        (notification.type !== 'SYSTEM' || notification.service !== 'USER_BOOK_EPISODE')) {
        content = `<span class="fromUser"><strong>@${notification.fromUserName}</strong>님</span> ` + sanitizeHtml(content, sanitizeOption);
    } else {
        content = sanitizeHtml(content, sanitizeOption);
    }

    if (link === null) {
        return <div><span dangerouslySetInnerHTML={{ __html: content }}></span></div>;
    } else {
        return (
            <button className="link" onClick={() => gotoPage(link)}>
                <span dangerouslySetInnerHTML={{ __html: content }}></span>
                &nbsp;<i className="icon_link fas fa-link"></i>
            </button>
        );
    }
}
export default NotificationContentItem;